/**
 * Guards for canvas gestures that create items (tool clicks, the N key,
 * paste).
 *
 * Dialogs, menus and the document editor render in portals outside the
 * canvas DOM, but React still bubbles their events through the canvas, so a
 * click inside one must not count as a click on empty canvas.
 */

const OVERLAY_SELECTOR = '[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"], .partnr-chat-window';

/** True unless the target is empty canvas: an item, or anything outside the canvas DOM (a portal). */
export function isOffCanvasOrOnItem(target: EventTarget | null, container: Element | null): boolean {
  if (!target || !(target instanceof Element)) return false;
  if (container && !container.contains(target)) return true;
  return !!target.closest('[data-canvas-item]');
}

/** True when keyboard focus is in a text field, rich-text editor, dialog or menu, where canvas shortcuts and paste must not act. */
export function isFocusInTextOrOverlay(active: Element | null): boolean {
  if (!active || active === document.body) return false;
  const tag = active.tagName.toLowerCase();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
  if ((active as HTMLElement).isContentEditable || active.closest('[contenteditable="true"]')) return true;
  return !!active.closest(OVERLAY_SELECTOR);
}
